// 图层元数据工具，统一管理图层的翻译、排序、过滤规则

import { sortArray } from "components/results/analysis-results/sortUtil";

/** 获取图层在排序数组中的索引 */
export const getLayerSortIndex = (layerId?: string): number => {
  if (!layerId) return Number.MAX_SAFE_INTEGER;
  const index = sortArray.indexOf(layerId);
  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
};

/** 按图层排序 ID 列表 */
export const sortByLayerOrder = (layerIds: string[]): string[] => {
  return [...layerIds].sort((a, b) => {
    const indexA = getLayerSortIndex(a);
    const indexB = getLayerSortIndex(b);
    return indexA - indexB;
  });
};

/** 获取图层中英文名称 */
export const getLayerDisplayName = (t: any, layerId: string): string => {
  return t(`layerId.${layerId}`) || layerId;
};

/** 过滤无效的数据标签 */
export const INVALID_VALUE_LABELS = new Set([
  "No Data",
  "No_Data",
  "Outside",
  "No Observation",
  "Waterbody"
]);

export const isValidValueLabel = (label: string): boolean => {
  return !INVALID_VALUE_LABELS.has(label);
};
